<template>
  <button
    class="salesflow-btn salesflow-btn-outline"
    @click="$emit('click')"
  >
    {{ __('Convidar usuário') }}
  </button>
</template>

<script>
import CardIconPlusCallAction from '../ui/cards/CardIconPlusCallAction';

export default {
  name: 'CardInviteUser',

  components: {
    CardIconPlusCallAction,
  },
};
</script>
